import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { applyRouteSurfaceForPath } from './lib/routeSurface';

const theme = typeof localStorage !== "undefined" ? localStorage.getItem("theme") : null;
if (theme === "dark") {
  document.documentElement.classList.add("dark");
}

applyRouteSurfaceForPath(window.location.pathname);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
